import Plyr from 'plyr';
import 'plyr/dist/plyr.css'
import './Videos.css'

export default function init(ratio) {
    console.log('data-plyr-video', document.querySelectorAll('[data-plyr-video]'));
    const r  = typeof ratio !== "undefined" ? ratio : '16:9';
    console.log('ratio', r);
    window.plyrPlayers = Array.from(document.querySelectorAll('[data-plyr-video]')).map((p) => new Plyr(p, {
        ratio: r,
    }));
}
